// extracted by mini-css-extract-plugin
export var container = "_af-0";
export var containerTopRight = "_af-1";